export function getUrgentClientOrderList(data) {
    let { getUrgentClientOrderListRequest, getUrgentClientOrderListError, getUrgentClientOrderListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_urgent_client_order_list',
        this.createBundle('get_urgent_client_order_list', { unused: data }, this.GET, getUrgentClientOrderListRequest, getUrgentClientOrderListResult, getUrgentClientOrderListError)
    )
}
